import React from "react";
import {
  styled,
  Theme,
  Typography,
  LinearProgress,
  Input,
  Tooltip,
  withStyles
} from "@material-ui/core";

export const TitleTypography = styled(Typography)(
  ({ theme }: { theme: Theme; component: React.ElementType }) => ({
    display: "inline",
    fontWeight: 400,
    fontSize: "5.0rem",
    lineHeight: "5.6rem",
    letterSpacing: "-1px",
    fontFamily: "Reckless, Georgia",
    [theme.breakpoints.down("xs")]: {
      fontSize: "2.4rem",
      lineHeight: "3.0rem",
      letterSpacing: "0px"
    }
  })
);

export const BrandTypography = styled(Typography)(
  ({ theme }: { theme: Theme; component?: React.ElementType }) => ({
    display: "inline",
    fontWeight: 400,
    fontSize: "2.4rem",
    lineHeight: "3.0rem",
    fontFamily: "Reckless, Georgia",
    [theme.breakpoints.down("xs")]: {
      fontSize: "2.4rem",
      lineHeight: "3.6rem",
      letterSpacing: "0px"
    }
  })
);

export const PriceTypography = styled(Typography)(({ theme }) => ({
  display: "inline",
  fontWeight: 400,
  fontSize: "4rem",
  lineHeight: "3.2rem",
  fontFamily: "Reckless, Georgia",
  [theme.breakpoints.down("xs")]: {
    fontSize: "3rem",
    lineHeight: "3.2rem"
  }
}));

export const InventoryProgressBar = styled(({ inventoryLevel, ...props }) => (
  <LinearProgress variant="determinate" {...props} />
))(({ theme, inventoryLevel }: { theme: Theme; inventoryLevel: string }) => ({
  height: "13px",
  width: "90px",
  borderRadius: "13px",
  backgroundColor: theme.palette.grey[300],
  "& > div": {
    borderRadius: "13px",
    background: IntentoryProgressBarColors[inventoryLevel]
  }
}));

export const IntentoryProgressBarColors = {
  LOW: "#FF4848",
  MEDIUM: "#FF8C33",
  GOOD: "#39B400"
};

export const IntentoryProgressBarLevels = {
  LOW: 25,
  MEDIUM: 50,
  GOOD: 100
};

export const CustomVariantInput = styled(Input)(({ theme }) => ({
  fontSize: "1.4rem",
  fontWeight: 600,
  borderRadius: "3px",
  "&::before": {
    display: "none"
  },
  "&::after": {
    display: "none"
  },
  "& .MuiNativeSelect-root": {
    paddingTop: "0px",
    paddingBottom: "0px",
    height: theme.spacing(3),
    paddingLeft: theme.spacing(0.5),
    paddingRight: theme.spacing(4),
    borderRadius: "3px"
  },
  "&.Mui-focused": {
    background: "none"
  },
  "& .MuiNativeSelect-icon": {
    width: "1.5rem",
    height: "1.5rem",
    color: theme.palette.common.black,
    top: "calc(50% - 0.75rem)",
    right: "4px"
  }
}));

export const InfoTooltip = withStyles(theme => ({
  tooltip: {
    backgroundColor: theme.palette.primary.main,
    borderRadius: "8px",
    padding: theme.spacing(2)
  },
  arrow: {
    color: theme.palette.primary.main
  }
}))(Tooltip);
